import { Navigate, Route, Routes, useParams } from 'react-router';
import { Trans } from '@lingui/react/macro';

import { CountBadge } from '@/design_system/CountBadge';
import Tabs from '@/design_system/Tabs';
import { Tab, TabList, TabPanel } from '@/design_system/Tabs/Tabs';
import { AgreementFromGetById } from '@/models/agreements';

import { ActionsTable } from './ActionsTable';
import { FeesTable } from './FeesTable';
import { PackActionsTable } from './PackActionsTable';
import { SparePartsTable } from './SparePartsTable';

export const PriceCatalogAgreementTables = ({ agreement }: { agreement: AgreementFromGetById }) => {
  const { '*': section } = useParams();

  const packPrices = agreement.prices.filter((price) => price.packActionTypeOrganization);
  const actionPrices = agreement.prices.filter((price) => price.actionTypeOrganization);
  const sparePartPrices = agreement.prices.filter((price) => price.sparePartTypeOrganization);
  const feePrices = agreement.prices.filter((price) => price.feeType);

  const defaultTab =
    packPrices.length > 0
      ? 'packs'
      : actionPrices.length > 0
        ? 'actions'
        : sparePartPrices.length > 0
          ? 'spare-parts'
          : feePrices.length > 0
            ? 'fees'
            : 'actions';

  return (
    <Tabs selectedKey={section || defaultTab}>
      <TabList>
        <Tab id="packs" href={`/settings_beta/network/agreements/${agreement.id}/packs`}>
          <Trans id="settings.organization.entities.agreements.detail.tab.packs">Packs</Trans>
          <CountBadge count={packPrices.length} variant="neutral" isActive={false} />
        </Tab>
        <Tab id="actions" href={`/settings_beta/network/agreements/${agreement.id}/actions`}>
          <Trans id="settings.organization.entities.agreements.detail.tab.actions">Actions</Trans>
          <CountBadge count={actionPrices.length} variant="neutral" isActive={false} />
        </Tab>
        <Tab
          id="spare-parts"
          href={`/settings_beta/network/agreements/${agreement.id}/spare-parts`}
        >
          <Trans id="settings.organization.entities.agreements.detail.tab.spare-parts">
            Spare parts
          </Trans>
          <CountBadge count={sparePartPrices.length} variant="neutral" isActive={false} />
        </Tab>
        <Tab id="fees" href={`/settings_beta/network/agreements/${agreement.id}/fees`}>
          <Trans id="settings.organization.entities.agreements.detail.tab.fees">Fees</Trans>
          <CountBadge count={feePrices.length} variant="neutral" isActive={false} />
        </Tab>
      </TabList>
      <TabPanel id={section || defaultTab}>
        <Routes>
          <Route
            path="packs"
            element={<PackActionsTable packActions={packPrices} agreement={agreement} />}
          />
          <Route
            path="actions"
            element={<ActionsTable actions={actionPrices} agreement={agreement} />}
          />
          <Route
            path="spare-parts"
            element={<SparePartsTable spareParts={sparePartPrices} agreement={agreement} />}
          />
          <Route path="fees" element={<FeesTable fees={feePrices} />} />
          <Route
            path=""
            element={
              <Navigate
                to={`/settings_beta/network/agreements/${agreement.id}/${defaultTab}`}
                replace
              />
            }
          />
        </Routes>
      </TabPanel>
    </Tabs>
  );
};
